import envConfig from "@/config/envConfig";

export const fetchBlockDetails = async <T = any>({
  block,
  pageSlug,
  limit,
  lang,
}: {
  block: any;
  pageSlug: string;
  limit?: number;
  lang?: string;
}): Promise<T> => {
  const payloadBlock = {
    ...block,
    ...(limit ? { limit } : {}),
  };
  try {
    const response = await fetch(`${envConfig.publicServerUrl}/api/v1/blocks/details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
      body: JSON.stringify({
        block: payloadBlock,
        pageSlug,
        itemIndex: block?.id,
        lang,
      }),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    return await response.json();
  } catch (err) {
    return err as any;
  }
};
